export const allocationsTranslations = {
  ru: {
    'allocations.page.title': 'Распределение платежей',
    'allocations.page.subtitle': 'Выберите документы Syrve, отредактируйте суммы и подтвердите распределение',
    'allocations.page.error.missingBankTransactionId': 'Не указан идентификатор банковской транзакции.',
    'allocations.page.error.loadBankTransaction': 'Не удалось загрузить банковскую транзакцию.',
    'allocations.page.backToCandidates': 'К кандидатам',
    'allocations.candidates.title': 'Документы-кандидаты',
    'allocations.candidates.subtitle': 'Выберите один или несколько документов для распределения',
    'allocations.candidates.build': 'Построить кандидатов',
    'allocations.candidates.error.load': 'Не удалось загрузить кандидатов.',
    'allocations.candidates.empty.title': 'Кандидаты не построены',
    'allocations.candidates.empty.description': 'После сопоставления контрагента нажмите «Построить кандидатов».',
    'allocations.candidates.empty.noneFound.title': 'Подходящие документы не найдены',
    'allocations.candidates.empty.noneFound.description': 'Проверьте неоплаченные документы Syrve для сопоставленного контрагента (сумма, валюта, outlet). Если документов нет — попросите администратора синхронизировать данные Syrve.',
    'allocations.candidates.selectAria': 'Выбрать {label}',
    'allocations.candidates.amountAria': 'Сумма для {label}',
    'allocations.candidates.openDocumentAria': 'Открыть накладную {label}',
    'allocations.candidates.documentPreview.title': 'Накладная',
    'allocations.candidates.documentPreview.openFull': 'Открыть накладную на отдельной странице',
    'allocations.candidates.unpaid': 'Неоплачено в iiko',
    'allocations.candidates.reserved': 'Уже распределено',
    'allocations.candidates.available': 'Доступно',
    'allocations.candidates.remainingAfter': 'Останется после операции',
    'allocations.table.document': 'Документ',
    'allocations.table.outlet': 'Outlet',
    'allocations.table.counterparty': 'Контрагент',
    'allocations.table.amounts': 'Суммы',
    'allocations.table.status': 'Статус',
    'allocations.table.suggested': 'Предложено',
    'allocations.table.confidence': 'Уверенность',
    'allocations.table.reason': 'Причина',
    'allocations.table.warnings': 'Предупреждения',
    'allocations.table.allocate': 'Распределить',
    'allocations.table.documentAmount': 'Сумма документа',
    'allocations.table.allocated': 'Распределено',
    'allocations.table.flags': 'Флаги',
    'allocations.table.id': 'ID',
    'allocations.table.created': 'Создано',
    'allocations.table.statusBefore': 'Статус до',
    'allocations.table.statusAfter': 'Ожидаемый статус',
    'allocations.table.debt': 'Задолженность',
    'allocations.outlet.undefined': 'Не определён',
    'allocations.amounts.total': 'Всего:',
    'allocations.amounts.paid': 'Оплачено:',
    'allocations.amounts.unpaid': 'К оплате:',
    'allocations.warning.selectOutletManually': 'Выберите документ и Outlet вручную.',
    'allocations.preview.build': 'Построить предпросмотр',
    'allocations.confirm.button': 'Подтвердить распределение',
    'allocations.preview.error': 'Не удалось построить предпросмотр.',
    'allocations.confirm.error': 'Не удалось подтвердить распределение.',
    'allocations.preview.title': 'Предпросмотр распределения',
    'allocations.summary.paymentAmount': 'Сумма платежа',
    'allocations.summary.allocated': 'Распределено',
    'allocations.summary.remaining': 'Остаток',
    'allocations.summary.warnings': 'Предупреждения',
    'allocations.flag.partialPayment': 'Частичная оплата',
    'allocations.flag.overpayment': 'Переплата',
    'allocations.preview.empty.title': 'Нет строк предпросмотра',
    'allocations.preview.empty.description': 'Выберите документы и постройте предпросмотр.',
    'allocations.confirm.title': 'Подтвердить распределение',
    'allocations.confirm.message': 'Распределение будет сохранено. Проведение в Syrve выполняется асинхронно через очередь.',
    'allocations.confirm.label': 'Подтвердить',
    'allocations.detail.notFound': 'Распределение не найдено',
    'allocations.detail.title': 'Распределение {id}…',
    'allocations.detail.subtitle': 'Банковская транзакция {bankTransactionId}',
    'allocations.detail.approve': 'Утвердить',
    'allocations.detail.queuePosting': 'В очередь проведения',
    'allocations.detail.summary': 'Сводка',
    'allocations.detail.bankTransaction': 'Банковская транзакция',
    'allocations.detail.rowVersion': 'RowVersion',
    'allocations.detail.queueBlocked': 'Текущее состояние распределения не позволяет поставить оплату в очередь.',
    'allocations.detail.approveError': 'Не удалось утвердить распределение. Обновите страницу и проверьте статус.',
    'allocations.detail.queueError': 'Не удалось поставить проведение в очередь. Проверьте предупреждения ниже (правило проведения, баланс выписки, outlet).',
    'allocations.detail.needsReviewQueueHint': 'Статус «Нужна проверка» не блокирует проведение. Нажмите «В очередь проведения», если кнопка активна.',
    'allocations.detail.postingQueuedHint': 'Проводка уже в очереди. Откройте Syrve → Очередь проведений и дождитесь статуса Posted/Reconciled.',
    'allocations.detail.linesTitle': 'Строки распределения',
    'allocations.debt.before': 'До:',
    'allocations.debt.after': 'После:',
    'allocations.detail.linesEmpty.title': 'Строки не найдены',
    'allocations.detail.linesEmpty.description': 'У распределения нет строк.',
    'allocations.detail.postingPreview': 'Предпросмотр проведения',
    'allocations.detail.postingDisabled': 'Проведение оплат отключено настройками',
    'allocations.detail.queueConfirm.title': 'Поставить в очередь проведения?',
    'allocations.detail.queueConfirm.message': 'Оплата будет отправлена асинхронно через outbox/worker, не синхронно из UI.',
    'allocations.detail.writeTarget.title': 'Куда провести оплату',
    'allocations.detail.writeTarget.hint': 'Выберите счёт и статью ДДС в Syrve. Если правило проведения не настроено, назначение делается вручную здесь.',
    'allocations.detail.writeTargetRequired': 'Выберите счёт и статью ДДС перед постановкой в очередь.',
    'allocations.list.title': 'Распределения платежей',
    'allocations.list.subtitle': 'Operational workspace: подтверждение и очередь проведения',
    'allocations.list.statusFilter': 'Статус: {status}',
    'allocations.list.empty': 'Распределений пока нет',
    'allocations.list.subtitleCount': 'Записей: {count}',
    'allocations.list.emptyHint': 'Список заполняется после Confirm на странице распределения (не после Preview). Откройте рабочий стол бухгалтера, выберите платёж и подтвердите распределение.',
    'allocations.list.openWorkbench': 'Перейти к рабочему столу бухгалтера',
    'allocations.list.error': 'Не удалось загрузить список. Проверьте организацию и Outlet в шапке.',
    'allocations.dispatch.title': 'Платежи в Syrve',
    'allocations.dispatch.subtitle': 'Один список: что отправить, что уже уходит в iiko, что готово',
    'allocations.dispatch.loading': 'Загружаем платежи…',
    'allocations.dispatch.refresh': 'Обновить',
    'allocations.dispatch.filters.all': 'Все',
    'allocations.dispatch.filters.action': 'Нужно действие',
    'allocations.dispatch.filters.processing': 'Отправляется',
    'allocations.dispatch.filters.done': 'Готово',
    'allocations.dispatch.filters.failed': 'Ошибка',
    'allocations.dispatch.column.document': 'Документ',
    'allocations.dispatch.column.status': 'Статус',
    'allocations.dispatch.column.nextStep': 'Следующий шаг',
    'allocations.dispatch.column.attempts': 'Попытки в iiko',
    'allocations.dispatch.column.action': 'Действие',
    'allocations.dispatch.action.continue': 'Открыть',
    'allocations.dispatch.action.send': 'Отправить',
    'allocations.dispatch.action.retry': 'Повторить',
    'allocations.dispatch.action.open': 'Подробнее',
    'allocations.dispatch.actionHint.continue': 'Откройте платёж и продолжите с текущего шага',
    'allocations.dispatch.actionHint.send': 'Выберите счёт и статью ДДС, затем отправьте в Syrve одной кнопкой',
    'allocations.dispatch.empty.title': 'Платежей для Syrve пока нет',
    'allocations.dispatch.empty.description': 'Сначала распределите платёж на рабочем столе бухгалтера — он появится здесь автоматически.',
    'allocations.dispatch.summary.total': 'Всего',
    'allocations.dispatch.summary.action': 'Нужно действие',
    'allocations.dispatch.summary.processing': 'Отправляется',
    'allocations.dispatch.summary.done': 'Готово',
    'allocations.dispatch.summary.pendingAmount': 'Сумма не завершённых',
    'allocations.bankCard.title': 'Банковский платёж',
    'allocations.bankCard.counterpartyBank': 'Контрагент (банк)',
    'allocations.bankCard.syrveMatch': 'Сопоставление Syrve',
    'allocations.bankCard.notMatched': 'Не сопоставлен',
    'workbench.filter.ready': 'Готово к одобрению',
    'workbench.filter.all': 'Все',
    'workbench.filter.posted': 'Проведённые',
    'workbench.filter.problem': 'Проблемные',
    'workbench.filter.unmatched': 'Не сопоставлены',
    'workbench.filter.conflict': 'Конфликт',
    'workbench.filter.review': 'Требует проверки',
    'workbench.filter.attention': 'Требует внимания',
    'workbench.filter.processing': 'В обработке',
    'workbench.filter.completed': 'Завершено',
    'workbench.filter.excluded': 'Исключено',
    'workbench.filters.secondary': 'Дополнительно',
    'workbench.state.attention': 'Нужно разобрать',
    'workbench.state.ready': 'Можно провести',
    'workbench.state.processing': 'Проводится',
    'workbench.state.completed': 'Проведено',
    'workbench.state.excluded': 'Не оплата поставщика',
    'workbench.table.document': 'Документ',
    'workbench.table.bank': 'Банк',
    'workbench.table.state': 'Состояние',
    'workbench.table.required': 'Что требуется',
    'workbench.table.select': 'Выбор',
    'workbench.drawer.title': 'Операция',
    'workbench.drawer.titleFrom': 'Операция от {date}',
    'workbench.drawer.sourceFile': 'Файл выписки',
    'workbench.drawer.required': 'Что требуется',
    'workbench.drawer.warnings': 'Предупреждения',
    'workbench.drawer.matchedRule': 'Сопоставлено по правилу',
    'workbench.drawer.writeTarget': 'Цель записи',
    'workbench.drawer.writeTargetPending': 'Будет определена при проведении',
    'workbench.drawer.writeTargetMissing': 'Не выбран счёт оплаты и статья ДДС — укажите на экране проведения',
    'workbench.drawer.writeTargetConflict': 'Конфликт правил счёта/ДДС — проверьте правила проведения',
    'workbench.drawer.bankAccountResolution': 'Банковский счёт и финансовый Account',
    'workbench.bankAccount.resolved': 'Банковский счёт сопоставлен',
    'workbench.reason.recognition_review_required': 'Нужна проверка распознавания выписки',
    'workbench.reason.recognition_failed': 'Ошибка распознавания выписки',
    'workbench.reason.import_quality_error': 'Ошибки качества импорта',
    'workbench.reason.balance_review_required': 'Баланс выписки не сходится',
    'workbench.reason.duplicate_review_required': 'Нужна проверка дубликатов',
    'workbench.reason.bank_account_mapping_required': 'Банковский счёт не сопоставлен с финансовым Account iiko',
    'workbench.reason.bank_account_mapping_conflict': 'Для банковского счёта найдено несколько активных сопоставлений',
    'workbench.reason.business_action_required': 'Операция ожидает выбора бизнес-действия в следующем этапе workflow',
    'workbench.reason.business_action_stale': 'Выбранное бизнес-действие устарело после изменения счёта или контрагента — подтвердите его заново',
    'workbench.reason.posting_intent_required': 'Бизнес-действие выбрано; требуется подготовка деталей проведения на следующем этапе',
    'workbench.reason.posting_intent_confirmation_required': 'Детали проведения подготовлены; требуется явное подтверждение оператора',
    'workbench.reason.posting_intent_stale': 'Детали проведения устарели после изменения исходных решений; подготовьте их заново',
    'workbench.reason.posting_execution_required': 'Детали подтверждены; проведение готово к запуску',
    'workbench.reason.posting_execution_in_progress': 'Проведение выполняется',
    'workbench.reason.posting_reconciliation_required': 'Исход проведения не подтверждён; требуется безопасная сверка',
    'workbench.reason.posting_execution_failed': 'Проведение завершилось ошибкой до подтверждённого результата',
    'workbench.reason.posting_completed': 'Проведение подтверждено сверкой',
    'workbench.reason.candidate_missing': 'Нет неоплаченного документа на сумму платежа у сопоставленного контрагента',
    'workbench.reason.candidate_ambiguous': 'Несколько документов-кандидатов — выберите вручную',
    'workbench.reason.outlet_ambiguous': 'Неоднозначный outlet',
    'workbench.reason.allocation_partial': 'Частичное распределение',
    'workbench.reason.allocation_overpayment': 'Переплата относительно документа',
    'workbench.reason.allocation_warning': 'Распределение требует проверки',
    'workbench.reason.write_target_missing': 'Не выбран счёт и статья ДДС',
    'workbench.reason.write_target_conflict': 'Конфликт правил счёта/ДДС',
    'workbench.reason.posting_failed': 'Проведение в Syrve не удалось',
    'workbench.reason.reconciliation_failed': 'Сверка после проведения не прошла',
    'workbench.reason.critical_anomaly': 'Критическая аномалия',
    'workbench.next.openPosting': 'Открыть проведение',
    'workbench.next.prepare': 'Открыть проведение',
    'workbench.next.approveAndQueue': 'Одобрить и провести',
    'workbench.next.openResult': 'Открыть результат',
    'workbench.next.unexclude': 'Вернуть в обработку',
    'workbench.action.reviewProblems': 'Разобрать проблемы',
    'workbench.action.approveReady': 'Одобрить готовые',
    'workbench.action.approveReady.hint': 'Доступно после batch approval',
    'workbench.batch.previewTitle': 'Одобрение готовых платежей',
    'workbench.batch.previewMessage': 'К одобрению: {eligible}. Исключено: {excluded}. Сумма: {total}. Предупреждений: {warnings}.',
    'workbench.batch.confirm': 'Одобрить batch',
    'workbench.batch.result': 'Batch: успешно {succeeded}, ошибок {failed}, пропущено {skipped}',
    'workbench.batch.error': 'Не удалось выполнить batch approval',
    'workbench.batch.noneEligible': 'Нет безопасных платежей для batch (исключено: {excluded})',
    'workbench.action.nextProblem': 'Следующая проблема',
    'workbench.action.unexclude': 'Вернуть',
    'workbench.action.unexcludeFull': 'Вернуть в обработку',
    'workbench.action.excludeNotPayment': 'Не относится к оплате',
    'workbench.action.advancedMatching': 'Расширенное сопоставление',
    'workbench.match.rememberRule': 'Запомнить',
    'workbench.match.rulePattern': 'Признак для автосопоставления',
    'workbench.match.rulePatternHint': 'По этому тексту будем искать этого контрагента в следующих выписках. Можно укоротить до устойчивого фрагмента имени.',
    'workbench.match.catalogMissing': 'Контрагент уже сопоставлен, но его нет в локальном справочнике. Можно подтвердить текущий выбор или синхронизировать поставщиков.',
    'workbench.match.showAdvanced': 'Дополнительно',
    'workbench.match.hideAdvanced': 'Скрыть дополнительно',
    'workbench.match.blockingConflict': 'Блокирующий конфликт правила: сопоставление сохранится, правило не создаётся.',
    'workbench.match.excludedHint': 'Операция исключена из оплаты поставщика. Можно вернуть её в обработку.',
    'workbench.action.prepare': 'Открыть проведение',
    'workbench.prepare.success': 'Кандидаты обновлены',
    'workbench.prepare.done': 'Подготовка завершена. Требуется решение по кандидатам.',
    'workbench.prepare.safeProposal': 'Безопасный документ: {document}',
    'workbench.prepare.counterpartyFromDocument': 'Контрагент определён по документу',
    'workbench.prepare.error': 'Не удалось подготовить операцию',
    'workbench.action.approveAndQueue': 'Одобрить и провести',
    'workbench.action.openAdvancedFlow': 'Открыть расширенный сценарий',
    'workbench.approve.queued': 'Платёж поставлен в очередь',
    'workbench.approve.error': 'Не удалось одобрить и поставить в очередь',
    'workbench.approve.risk.title': 'Подтвердите рискованную операцию',
    'workbench.approve.risk.confirm': 'Одобрить с риском',
    'workbench.approve.risk.unknown': 'Обнаружены предупреждения',
    'workbench.approve.risk.summary': 'Сумма: {amount}. Предупреждения: {warnings}. {message}',
    'workbench.filters.workflow': 'Статус',
    'workbench.filters.issues': 'Проблемы',
    'workbench.filters.dateFrom': 'Дата с',
    'workbench.filters.dateTo': 'Дата по',
    'workbench.filters.document': 'Документ',
    'workbench.filters.document.placeholder': 'Имя файла выписки',
    'workbench.noDescription': 'Нет описания',
    'workbench.match.noMatch': 'Нет сопоставления',
    'workbench.match.noMatchReason': 'Контрагент не сопоставлен с Syrve.',
    'workbench.match.noCounterpartyFound': 'Не найден подходящий контрагент.',
    'workbench.match.needsReview': 'Требует проверки',
    'workbench.match.lowConfidenceReason': 'Уверенность сопоставления ниже безопасного порога.',
    'workbench.match.manual': 'Вручную',
    'workbench.match.manualReason': 'Контрагент выбран вручную.',
    'workbench.match.auto': 'Авто',
    'workbench.match.autoReason': 'Автоматическое сопоставление принято.',
    'workbench.match.short.unmatched': 'Не сопоставлен',
    'workbench.match.short.review': 'Проверить',
    'workbench.match.short.manual': 'Вручную',
    'workbench.match.short.rule': 'По правилу',
    'workbench.match.short.auto': 'Авто',
    'workbench.warning.counterpartyUnmatched': 'Контрагент не сопоставлен (не блокирует начисление)',
    'workbench.warning.lowConfidence': 'Низкая уверенность сопоставления',
    'workbench.warning.importWarnings': 'Предупреждения импорта: {count}',
    'workbench.warning.importErrors': 'Ошибки импорта: {count}',
    'workbench.warning.duplicateCandidates': 'В импорте есть кандидаты-дубликаты: {count}',
    'workbench.warning.balanceReviewRequired': 'Баланс выписки не сходится',
    'workbench.warning.balanceReviewRequired.hint': 'Информация: пересчёт баланса не совпал с данными банка. Банковская выписка — источник истины; проведение не блокируется.',
    'workbench.action.match': 'Сопоставить',
    'workbench.action.edit': 'Изменить',
    'workbench.action.allocate': 'Распределить',
    'workbench.action.rule': 'Правило',
    'workbench.noBlockers': 'Нет блокеров',
    'workbench.reason': 'Причина',
    'workbench.table.date': 'Дата',
    'workbench.table.amount': 'Сумма',
    'workbench.table.direction': 'Д/К',
    'workbench.table.purpose': 'Назначение',
    'workbench.table.counterparty': 'Контрагент Syrve',
    'workbench.table.matching': 'Сопоставление',
    'workbench.table.allocation': 'Распределение',
    'workbench.table.outlet': 'Outlet',
    'workbench.table.warnings': 'Предупреждения',
    'workbench.table.actions': 'Действия',
    'workbench.drawer.bankCounterparty': 'Контрагент из выписки',
    'workbench.drawer.statementText': 'Из выписки',
    'workbench.counterparty.notSpecified': '—',
    'workbench.counterparty.notMatched': 'Не сопоставлен',
    'workbench.counterparty.fromBank': 'из выписки: {name}',
    'workbench.allocation.notAllocated': 'Не распределено',
    'workbench.allocation.inProgress': 'Распределено',
    'workbench.allocation.processing': 'Отправляется',
    'workbench.allocation.posted': 'Проведено',
    'workbench.allocation.failed': 'Ошибка проведения',
    'workbench.allocation.title': 'Распределение',
    'workbench.allocation.hint': 'Разнесите всю сумму операции по статьям ДДС и счетам Syrve. Неразнесённый остаток недопустим. Тип операции не выбирается — его задают счёт и ДДС.',
    'workbench.allocation.col.dds': 'ДДС',
    'workbench.allocation.col.account': 'Корр. счёт',
    'workbench.allocation.col.comment': 'Комментарий',
    'workbench.allocation.col.amount': 'Сумма',
    'workbench.allocation.pickDds': 'Статья ДДС',
    'workbench.allocation.pickAccount': 'Корр. счёт Syrve',
    'workbench.allocation.ownAccount': 'Свой счёт: {name}',
    'workbench.allocation.ownAccountMissing': 'Свой счёт не задан',
    'workbench.allocation.openBankAccounts': 'Настроить счета банка',
    'workbench.allocation.commentPlaceholder': 'Комментарий',
    'workbench.allocation.add': 'Добавить строку',
    'workbench.allocation.remove': 'Удалить строку',
    'workbench.allocation.submit': 'Отправить распределение',
    'workbench.allocation.balanced': 'Сумма разнесена полностью',
    'workbench.allocation.remaining': 'Осталось разнести: {amount}',
    'workbench.allocation.over': 'Перебор: {amount}',
    'workbench.allocation.sumMismatch': 'Сумма строк {allocated} должна быть равна сумме операции {target}',
    'workbench.allocation.fieldsRequired': 'В каждой строке укажите ДДС, счёт и сумму больше нуля',
    'workbench.allocation.needBankAccount': 'Сначала сопоставьте банк с финансовым Account iiko в «Счета банка»',
    'workbench.allocation.needMatch': 'Сначала нажмите «Сопоставить» контрагента (или «Не относится к оплате»)',
    'workbench.allocation.needDepartment': 'Выберите подразделение для проводки',
    'workbench.allocation.needDepartmentEmpty': 'В iiko нет доступных подразделений для этой проводки',
    'workbench.allocation.department': 'Подразделение',
    'workbench.allocation.pickDepartment': 'Подразделение',
    'workbench.allocation.singleLineOnly': 'Пока можно отправить только одну строку распределения. Несколько строк — следующим шагом API.',
    'workbench.allocation.bankError': 'Не удалось сохранить сопоставление банковского счёта',
    'workbench.allocation.refsError': 'Не удалось загрузить справочники счетов и ДДС Syrve',
    'workbench.allocation.draftSaved': 'Черновик распределения сохранён ({count} стр.). Проведение в iiko — следующим шагом.',
    'workbench.allocation.draftSaveError': 'Не удалось сохранить черновик распределения в браузере',
    'workbench.allocation.submitted': 'Распределение отправлено в очередь проведения iiko',
    'workbench.allocation.submitError': 'Не удалось отправить распределение',
    'workbench.warning.postingFailed': 'Проведение в Syrve не удалось',
    'workbench.action.open': 'Открыть',
    'workbench.page.title': 'Рабочее место бухгалтера',
    'workbench.page.subtitle': 'Проверка банковских строк: сопоставление, распределение и причины остановки',
    'workbench.action.uploadStatement': 'Загрузить выписку',
    'workbench.hint': 'Показаны строки из первых {limit} актуальных импортов. «К проведению» — сопоставленные без блокеров. Проведённые скрыты в рабочих фильтрах.',
    'workbench.loading.imports': 'Загружаем последние банковские импорты…',
    'workbench.error.imports': 'Не удалось загрузить импорты',
    'workbench.loading.transactions': 'Загружаем банковские строки…',
    'workbench.error.transactions': 'Не удалось загрузить транзакции',
    'workbench.empty.title': 'Нет строк для выбранного фильтра',
    'workbench.empty.description': 'Попробуйте другой фильтр или загрузите новую выписку.',
    'workbench.action.post': 'Провести',
    'workbench.action.confirmBalance': 'Подтвердить баланс',
    'postingFlow.page.title': 'Проведение платежа',
    'postingFlow.page.subtitle': 'Распределите оплату, выберите счёт и дождитесь результата в Syrve',
    'postingFlow.page.titlePosted': 'Проведённый платёж',
    'postingFlow.page.subtitlePosted': 'Оплата уже проведена и сверена в Syrve',
    'postingFlow.backToWorkbench': 'К рабочему столу',
    'postingFlow.back': 'Назад',
    'postingFlow.steps.allocate': 'Распределить',
    'postingFlow.steps.writeTarget': 'Куда провести',
    'postingFlow.steps.result': 'Результат',
    'postingFlow.step.allocate.title': 'Распределить оплату',
    'postingFlow.step.allocate.subtitle': 'Выберите документы и суммы, затем подтвердите распределение одной кнопкой',
    'postingFlow.step.allocate.confirm': 'Подтвердить распределение',
    'postingFlow.settlement.allocationMethod': 'Метод распределения',
    'postingFlow.settlement.method.fifo': 'FIFO',
    'postingFlow.settlement.method.manual': 'Вручную',
    'postingFlow.settlement.bankPayment': 'Сумма банковского платежа',
    'postingFlow.settlement.documentSettlement': 'Погашение задолженности',
    'postingFlow.settlement.requiredAdvance': 'Будущий аванс поставщику',
    'postingFlow.settlement.unallocated': 'Нераспределено из банковского платежа',
    'postingFlow.settlement.invoiceDebtRemaining': 'Останется задолженность по документам',
    'postingFlow.settlement.partialDocument': 'Частичная оплата',
    'postingFlow.step.writeTarget.title': 'Куда провести',
    'postingFlow.step.writeTarget.subtitle': 'Укажите счёт и статью ДДС, затем отправьте оплату в Syrve',
    'postingFlow.step.writeTarget.empty': 'Выберите счёт и статью ДДС — без этого провести оплату нельзя.',
    'postingFlow.step.writeTarget.rememberedHint': 'Подставлен запомненный ранее счёт и ДДС. При необходимости измените.',
    'postingFlow.step.writeTarget.remember': 'Запомнить выбор для следующих проведений',
    'postingFlow.step.writeTarget.cta': 'Провести в Syrve',
    'postingFlow.step.writeTarget.error': 'Не удалось провести оплату в Syrve',
    'postingFlow.step.writeTarget.editAllocation': 'Назад к распределению',
    'postingFlow.step.writeTarget.cancelError': 'Не удалось отменить распределение',
    'postingFlow.block.balanceReview.hint': 'Баланс банковской выписки не сходится с пересчётом — информационное предупреждение. Банк является источником истины; проведение не блокируется.',
    'postingFlow.block.balanceReview.cta': 'Открыть качество импорта',
    'postingFlow.step.result.title': 'Результат проведения',
    'postingFlow.step.result.successTitle': 'Оплата проведена',
    'postingFlow.step.result.successPrefix': 'Документ',
    'postingFlow.step.result.successSuffix': 'оплачен и сверен в Syrve. Можно нажать «Готово».',
    'postingFlow.step.result.successSuffixReadOnly': 'оплачен и сверен в Syrve.',
    'postingFlow.step.result.success': 'Документ {document} оплачен и сверен в Syrve. Можно нажать «Готово».',
    'postingFlow.step.result.successReadOnly': 'Документ {document} оплачен и сверен в Syrve.',
    'postingFlow.step.result.openDocument': 'Открыть документ в Pay',
    'postingFlow.step.result.failed': 'Проведение завершилось ошибкой',
    'postingFlow.step.result.pending': 'Проведение выполняется. Страница обновится автоматически.',
    'postingFlow.step.result.approvalRequired': 'Проведение ожидает ручного утверждения. Нажмите «Утвердить и отправить», чтобы worker отправил оплату в iiko.',
    'postingFlow.step.result.approve': 'Утвердить и отправить',
    'postingFlow.step.result.approveError': 'Не удалось утвердить проведение. Обновите страницу и проверьте статус.',
    'postingFlow.step.result.retry': 'Повторить',
    'postingFlow.step.result.reconcile': 'Сверить вручную',
    'postingFlow.step.result.liveReadback': 'В Syrve: {status}, остаток к оплате {unpaid}',
    'postingFlow.step.result.done': 'Готово',
    'postingFlow.summary.title': 'Сводка',
    'postingFlow.summary.outcome': 'Итог',
    'postingFlow.summary.outcomeSuccess': 'Оплата проведена и сверена',
    'postingFlow.summary.outcomeFailed': 'Проведение не удалось',
    'postingFlow.summary.outcomePending': 'Проведение выполняется',
    'postingFlow.summary.allocationStatus': 'Статус распределения',
    'postingFlow.summary.postingStatus': 'Статус проведения',
    'postingFlow.diagnostics.title': 'Диагностика',
    'postingFlow.diagnostics.allocation': 'Распределение',
    'postingFlow.diagnostics.preflight': 'Preflight',
    'postingFlow.diagnostics.workerAttempts': 'Попытки worker',
    'postingFlow.diagnostics.evidence': 'Evidence',
    'postingFlow.diagnostics.attempts': 'Попытки',
    'postingFlow.advanced.allocationDetail': 'Подробности распределения',
    'postingFlow.advanced.postingDetail': 'Подробности проведения',
  },
  en: {
    'allocations.page.title': 'Payment allocation',
    'allocations.page.subtitle': 'Select Syrve documents, edit amounts, and confirm allocation',
    'allocations.page.error.missingBankTransactionId': 'Bank transaction ID is not specified.',
    'allocations.page.error.loadBankTransaction': 'Failed to load bank transaction.',
    'allocations.page.backToCandidates': 'Back to candidates',
    'allocations.candidates.title': 'Candidate documents',
    'allocations.candidates.subtitle': 'Select one or more documents for allocation',
    'allocations.candidates.build': 'Build candidates',
    'allocations.candidates.error.load': 'Failed to load candidates.',
    'allocations.candidates.empty.title': 'Candidates not built',
    'allocations.candidates.empty.description': 'After matching the counterparty, click “Build candidates”.',
    'allocations.candidates.empty.noneFound.title': 'No matching documents found',
    'allocations.candidates.empty.noneFound.description': 'Check unpaid Syrve documents for the matched counterparty (amount, currency, outlet). If none exist, ask an administrator to sync Syrve data.',
    'allocations.candidates.selectAria': 'Select {label}',
    'allocations.candidates.amountAria': 'Amount for {label}',
    'allocations.candidates.openDocumentAria': 'Open invoice {label}',
    'allocations.candidates.documentPreview.title': 'Invoice',
    'allocations.candidates.documentPreview.openFull': 'Open invoice on a separate page',
    'allocations.candidates.unpaid': 'Unpaid in iiko',
    'allocations.candidates.reserved': 'Already allocated',
    'allocations.candidates.available': 'Available',
    'allocations.candidates.remainingAfter': 'Remaining after operation',
    'allocations.table.document': 'Document',
    'allocations.table.outlet': 'Outlet',
    'allocations.table.counterparty': 'Counterparty',
    'allocations.table.amounts': 'Amounts',
    'allocations.table.status': 'Status',
    'allocations.table.suggested': 'Suggested',
    'allocations.table.confidence': 'Confidence',
    'allocations.table.reason': 'Reason',
    'allocations.table.warnings': 'Warnings',
    'allocations.table.allocate': 'Allocate',
    'allocations.table.documentAmount': 'Document amount',
    'allocations.table.allocated': 'Allocated',
    'allocations.table.flags': 'Flags',
    'allocations.table.id': 'ID',
    'allocations.table.created': 'Created',
    'allocations.table.statusBefore': 'Status before',
    'allocations.table.statusAfter': 'Expected status',
    'allocations.table.debt': 'Outstanding',
    'allocations.outlet.undefined': 'Undefined',
    'allocations.amounts.total': 'Total:',
    'allocations.amounts.paid': 'Paid:',
    'allocations.amounts.unpaid': 'Due:',
    'allocations.warning.selectOutletManually': 'Select the document and Outlet manually.',
    'allocations.preview.build': 'Build preview',
    'allocations.confirm.button': 'Confirm allocation',
    'allocations.preview.error': 'Failed to build preview.',
    'allocations.confirm.error': 'Failed to confirm allocation.',
    'allocations.preview.title': 'Allocation preview',
    'allocations.summary.paymentAmount': 'Payment amount',
    'allocations.summary.allocated': 'Allocated',
    'allocations.summary.remaining': 'Remaining',
    'allocations.summary.warnings': 'Warnings',
    'allocations.flag.partialPayment': 'Partial payment',
    'allocations.flag.overpayment': 'Overpayment',
    'allocations.preview.empty.title': 'No preview lines',
    'allocations.preview.empty.description': 'Select documents and build a preview.',
    'allocations.confirm.title': 'Confirm allocation',
    'allocations.confirm.message': 'The allocation will be saved. Posting to Syrve runs asynchronously via the queue.',
    'allocations.confirm.label': 'Confirm',
    'allocations.detail.notFound': 'Allocation not found',
    'allocations.detail.title': 'Allocation {id}…',
    'allocations.detail.subtitle': 'Bank transaction {bankTransactionId}',
    'allocations.detail.approve': 'Approve',
    'allocations.detail.queuePosting': 'Queue posting',
    'allocations.detail.summary': 'Summary',
    'allocations.detail.bankTransaction': 'Bank transaction',
    'allocations.detail.rowVersion': 'RowVersion',
    'allocations.detail.queueBlocked': 'The current allocation state does not allow queuing payment posting.',
    'allocations.detail.approveError': 'Failed to approve allocation. Refresh the page and check the status.',
    'allocations.detail.queueError': 'Failed to queue posting. Check warnings below (posting rule, import balance, outlet).',
    'allocations.detail.needsReviewQueueHint': 'Needs review does not block posting. Click Queue posting when the button is enabled.',
    'allocations.detail.postingQueuedHint': 'Posting is already queued. Open Syrve → Posting queue and wait for Posted/Reconciled.',
    'allocations.detail.linesTitle': 'Allocation lines',
    'allocations.debt.before': 'Before:',
    'allocations.debt.after': 'After:',
    'allocations.detail.linesEmpty.title': 'No lines found',
    'allocations.detail.linesEmpty.description': 'This allocation has no lines.',
    'allocations.detail.postingPreview': 'Posting preview',
    'allocations.detail.postingDisabled': 'Payment posting is disabled by settings',
    'allocations.detail.queueConfirm.title': 'Queue for posting?',
    'allocations.detail.queueConfirm.message': 'Payment will be sent asynchronously via outbox/worker, not synchronously from the UI.',
    'allocations.detail.writeTarget.title': 'Payment write target',
    'allocations.detail.writeTarget.hint': 'Select Syrve account and cash-flow article. If no posting rule matches, assign the target manually here.',
    'allocations.detail.writeTargetRequired': 'Select account and cash-flow article before queueing.',
    'allocations.list.title': 'Payment allocations',
    'allocations.list.subtitle': 'Operational workspace: confirmation and posting queue',
    'allocations.list.statusFilter': 'Status: {status}',
    'allocations.list.empty': 'No allocations yet',
    'allocations.list.subtitleCount': 'Records: {count}',
    'allocations.list.emptyHint': 'The list is populated after Confirm on the allocation page (not Preview). Open the accountant workbench, pick a payment, and confirm allocation.',
    'allocations.list.openWorkbench': 'Open accountant workbench',
    'allocations.list.error': 'Failed to load the list. Check organization and Outlet in the header.',
    'allocations.dispatch.title': 'Payments to Syrve',
    'allocations.dispatch.subtitle': 'One list: what to send, what is in flight to iiko, and what is done',
    'allocations.dispatch.loading': 'Loading payments…',
    'allocations.dispatch.refresh': 'Refresh',
    'allocations.dispatch.filters.all': 'All',
    'allocations.dispatch.filters.action': 'Needs action',
    'allocations.dispatch.filters.processing': 'Sending',
    'allocations.dispatch.filters.done': 'Done',
    'allocations.dispatch.filters.failed': 'Failed',
    'allocations.dispatch.column.document': 'Document',
    'allocations.dispatch.column.status': 'Status',
    'allocations.dispatch.column.nextStep': 'Next step',
    'allocations.dispatch.column.attempts': 'iiko attempts',
    'allocations.dispatch.column.action': 'Action',
    'allocations.dispatch.action.continue': 'Open',
    'allocations.dispatch.action.send': 'Send',
    'allocations.dispatch.action.retry': 'Retry',
    'allocations.dispatch.action.open': 'Details',
    'allocations.dispatch.actionHint.continue': 'Open the payment and continue from the current step',
    'allocations.dispatch.actionHint.send': 'Pick account and cash-flow article, then send to Syrve in one click',
    'allocations.dispatch.empty.title': 'No Syrve payments yet',
    'allocations.dispatch.empty.description': 'Allocate a payment on the accountant workbench first — it will appear here automatically.',
    'allocations.dispatch.summary.total': 'Total',
    'allocations.dispatch.summary.action': 'Needs action',
    'allocations.dispatch.summary.processing': 'Sending',
    'allocations.dispatch.summary.done': 'Done',
    'allocations.dispatch.summary.pendingAmount': 'Pending amount',
    'allocations.bankCard.title': 'Bank payment',
    'allocations.bankCard.counterpartyBank': 'Counterparty (bank)',
    'allocations.bankCard.syrveMatch': 'Syrve matching',
    'allocations.bankCard.notMatched': 'Not matched',
    'workbench.filter.ready': 'Ready to post',
    'workbench.filter.all': 'In progress',
    'workbench.filter.posted': 'Posted',
    'workbench.filter.problem': 'Problematic',
    'workbench.filter.unmatched': 'Unmatched',
    'workbench.filter.conflict': 'Conflict',
    'workbench.filter.review': 'Needs review',
    'workbench.filter.attention': 'Needs attention',
    'workbench.filter.processing': 'Processing',
    'workbench.filter.completed': 'Completed',
    'workbench.filter.excluded': 'Excluded',
    'workbench.filters.secondary': 'Secondary',
    'workbench.state.attention': 'Needs review',
    'workbench.state.ready': 'Ready to post',
    'workbench.state.processing': 'Posting',
    'workbench.state.completed': 'Posted',
    'workbench.state.excluded': 'Not a supplier payment',
    'workbench.table.document': 'Document',
    'workbench.table.bank': 'Bank',
    'workbench.table.state': 'State',
    'workbench.table.required': 'Required',
    'workbench.table.select': 'Select',
    'workbench.drawer.title': 'Operation',
    'workbench.drawer.titleFrom': 'Operation of {date}',
    'workbench.drawer.sourceFile': 'Statement file',
    'workbench.drawer.required': 'Required',
    'workbench.drawer.warnings': 'Warnings',
    'workbench.drawer.matchedRule': 'Matched by rule',
    'workbench.drawer.writeTarget': 'Write target',
    'workbench.drawer.writeTargetPending': 'Resolved during posting',
    'workbench.drawer.writeTargetMissing': 'Payment account and cash-flow article not selected — set them on the posting screen',
    'workbench.drawer.writeTargetConflict': 'Account/cash-flow rule conflict — review posting rules',
    'workbench.drawer.bankAccountResolution': 'Bank account and financial Account',
    'workbench.bankAccount.resolved': 'Bank account is mapped',
    'workbench.reason.recognition_review_required': 'Bank recognition review required',
    'workbench.reason.recognition_failed': 'Bank recognition failed',
    'workbench.reason.import_quality_error': 'Import quality errors',
    'workbench.reason.balance_review_required': 'Statement balance does not match',
    'workbench.reason.duplicate_review_required': 'Duplicate review required',
    'workbench.reason.bank_account_mapping_required': 'Bank account is not mapped to an iiko financial Account',
    'workbench.reason.bank_account_mapping_conflict': 'Multiple active mappings match this bank account',
    'workbench.reason.business_action_required': 'Waiting for business-action selection in the next workflow stage',
    'workbench.reason.business_action_stale': 'The selected business action is stale after an account or counterparty change; select it again',
    'workbench.reason.posting_intent_required': 'Business action selected; posting details must be prepared in the next workflow stage',
    'workbench.reason.posting_intent_confirmation_required': 'Posting details are ready and require explicit operator confirmation',
    'workbench.reason.posting_intent_stale': 'Posting details are stale after an upstream change; rebuild them',
    'workbench.reason.posting_execution_required': 'Posting details are confirmed and ready to execute',
    'workbench.reason.posting_execution_in_progress': 'Posting execution is in progress',
    'workbench.reason.posting_reconciliation_required': 'The posting outcome is unconfirmed and requires safe reconciliation',
    'workbench.reason.posting_execution_failed': 'Posting failed before a confirmed result was obtained',
    'workbench.reason.posting_completed': 'Posting was confirmed by reconciliation',
    'workbench.reason.candidate_missing': 'No unpaid document for the payment amount under the matched counterparty',
    'workbench.reason.candidate_ambiguous': 'Multiple document candidates — choose manually',
    'workbench.reason.outlet_ambiguous': 'Ambiguous outlet',
    'workbench.reason.allocation_partial': 'Partial allocation',
    'workbench.reason.allocation_overpayment': 'Overpayment relative to document',
    'workbench.reason.allocation_warning': 'Allocation needs review',
    'workbench.reason.write_target_missing': 'Payment account and cash-flow article not selected',
    'workbench.reason.write_target_conflict': 'Account/cash-flow rule conflict',
    'workbench.reason.posting_failed': 'Syrve posting failed',
    'workbench.reason.reconciliation_failed': 'Posting reconciliation failed',
    'workbench.reason.critical_anomaly': 'Critical anomaly',
    'workbench.next.openPosting': 'Open posting',
    'workbench.next.prepare': 'Open posting',
    'workbench.next.approveAndQueue': 'Approve and queue',
    'workbench.next.openResult': 'Open result',
    'workbench.next.unexclude': 'Return to processing',
    'workbench.action.reviewProblems': 'Review problems',
    'workbench.action.approveReady': 'Approve ready',
    'workbench.action.approveReady.hint': 'Available after batch approval',
    'workbench.batch.previewTitle': 'Approve ready payments',
    'workbench.batch.previewMessage': 'Eligible: {eligible}. Excluded: {excluded}. Total: {total}. Warnings: {warnings}.',
    'workbench.batch.confirm': 'Approve batch',
    'workbench.batch.result': 'Batch: succeeded {succeeded}, failed {failed}, skipped {skipped}',
    'workbench.batch.error': 'Batch approval failed',
    'workbench.batch.noneEligible': 'No safe payments for batch (excluded: {excluded})',
    'workbench.action.nextProblem': 'Next problem',
    'workbench.action.unexclude': 'Restore',
    'workbench.action.unexcludeFull': 'Return to processing',
    'workbench.action.excludeNotPayment': 'Not a payment',
    'workbench.action.advancedMatching': 'Advanced matching',
    'workbench.match.rememberRule': 'Remember',
    'workbench.match.rulePattern': 'Auto-match pattern',
    'workbench.match.rulePatternHint': 'Future statements will match this counterparty when this text is found. You can shorten it to a stable name fragment.',
    'workbench.match.catalogMissing': 'Counterparty is already matched but missing from the local catalog. Confirm the current choice or sync suppliers.',
    'workbench.match.showAdvanced': 'Advanced',
    'workbench.match.hideAdvanced': 'Hide advanced',
    'workbench.match.blockingConflict': 'Blocking rule conflict: match will be saved, rule will not be created.',
    'workbench.match.excludedHint': 'Operation is excluded from supplier payment. You can return it to processing.',
    'workbench.action.prepare': 'Open posting',
    'workbench.prepare.success': 'Candidates refreshed',
    'workbench.prepare.done': 'Preparation finished. Candidate decision required.',
    'workbench.prepare.safeProposal': 'Safe document: {document}',
    'workbench.prepare.counterpartyFromDocument': 'Counterparty resolved from document',
    'workbench.prepare.error': 'Failed to prepare operation',
    'workbench.action.approveAndQueue': 'Approve and queue',
    'workbench.action.openAdvancedFlow': 'Open advanced flow',
    'workbench.approve.queued': 'Payment queued for posting',
    'workbench.approve.error': 'Failed to approve and queue',
    'workbench.approve.risk.title': 'Confirm risky payment',
    'workbench.approve.risk.confirm': 'Approve with risk',
    'workbench.approve.risk.unknown': 'Warnings detected',
    'workbench.approve.risk.summary': 'Amount: {amount}. Warnings: {warnings}. {message}',
    'workbench.filters.workflow': 'Status',
    'workbench.filters.issues': 'Issues',
    'workbench.filters.dateFrom': 'Date from',
    'workbench.filters.dateTo': 'Date to',
    'workbench.filters.document': 'Document',
    'workbench.filters.document.placeholder': 'Statement file name',
    'workbench.noDescription': 'No description',
    'workbench.match.noMatch': 'No match',
    'workbench.match.noMatchReason': 'Counterparty is not matched to Syrve.',
    'workbench.match.noCounterpartyFound': 'No suitable counterparty found.',
    'workbench.match.needsReview': 'Needs review',
    'workbench.match.lowConfidenceReason': 'Match confidence is below the safe threshold.',
    'workbench.match.manual': 'Manual',
    'workbench.match.manualReason': 'Counterparty selected manually.',
    'workbench.match.auto': 'Auto',
    'workbench.match.autoReason': 'Automatic match accepted.',
    'workbench.match.short.unmatched': 'Unmatched',
    'workbench.match.short.review': 'Review',
    'workbench.match.short.manual': 'Manual',
    'workbench.match.short.rule': 'By rule',
    'workbench.match.short.auto': 'Auto',
    'workbench.warning.counterpartyUnmatched': 'Counterparty not matched (does not block allocation)',
    'workbench.warning.lowConfidence': 'Low match confidence',
    'workbench.warning.importWarnings': 'Import warnings: {count}',
    'workbench.warning.importErrors': 'Import errors: {count}',
    'workbench.warning.duplicateCandidates': 'Import has duplicate candidates: {count}',
    'workbench.warning.balanceReviewRequired': 'Statement balance does not match',
    'workbench.warning.balanceReviewRequired.hint': 'Informational: recalculated balance does not match the bank file. The bank statement is the source of truth; posting is not blocked.',
    'workbench.action.match': 'Match',
    'workbench.action.edit': 'Edit',
    'workbench.action.allocate': 'Allocate',
    'workbench.action.rule': 'Rule',
    'workbench.noBlockers': 'No blockers',
    'workbench.reason': 'Reason',
    'workbench.table.date': 'Date',
    'workbench.table.amount': 'Amount',
    'workbench.table.direction': 'D/C',
    'workbench.table.purpose': 'Purpose',
    'workbench.table.counterparty': 'Syrve counterparty',
    'workbench.table.matching': 'Matching',
    'workbench.table.allocation': 'Allocation',
    'workbench.table.outlet': 'Outlet',
    'workbench.table.warnings': 'Warnings',
    'workbench.table.actions': 'Actions',
    'workbench.drawer.bankCounterparty': 'Counterparty from statement',
    'workbench.drawer.statementText': 'From statement',
    'workbench.counterparty.notSpecified': '—',
    'workbench.counterparty.notMatched': 'Not matched',
    'workbench.counterparty.fromBank': 'from statement: {name}',
    'workbench.allocation.notAllocated': 'Not allocated',
    'workbench.allocation.inProgress': 'Allocated',
    'workbench.allocation.processing': 'Sending',
    'workbench.allocation.posted': 'Posted',
    'workbench.allocation.failed': 'Posting failed',
    'workbench.allocation.title': 'Allocation',
    'workbench.allocation.hint': 'Allocate the full transaction amount across Syrve cash-flow articles and accounts. Unallocated remainder is not allowed. Operation type is not selected — account and cash-flow define it.',
    'workbench.allocation.col.dds': 'Cash flow',
    'workbench.allocation.col.account': 'Corr. account',
    'workbench.allocation.col.comment': 'Comment',
    'workbench.allocation.col.amount': 'Amount',
    'workbench.allocation.pickDds': 'Cash-flow article',
    'workbench.allocation.pickAccount': 'Syrve corr. account',
    'workbench.allocation.ownAccount': 'Own account: {name}',
    'workbench.allocation.ownAccountMissing': 'Own account is not mapped',
    'workbench.allocation.openBankAccounts': 'Configure bank accounts',
    'workbench.allocation.commentPlaceholder': 'Comment',
    'workbench.allocation.add': 'Add line',
    'workbench.allocation.remove': 'Remove line',
    'workbench.allocation.submit': 'Submit allocation',
    'workbench.allocation.balanced': 'Fully allocated',
    'workbench.allocation.remaining': 'Remaining: {amount}',
    'workbench.allocation.over': 'Over by: {amount}',
    'workbench.allocation.sumMismatch': 'Line total {allocated} must equal transaction amount {target}',
    'workbench.allocation.fieldsRequired': 'Each line needs cash flow, account, and amount greater than zero',
    'workbench.allocation.needBankAccount': 'Map the bank to an iiko financial Account in Bank accounts first',
    'workbench.allocation.needMatch': 'Match the counterparty first (or mark as not a payment)',
    'workbench.allocation.needDepartment': 'Select a department for the posting',
    'workbench.allocation.needDepartmentEmpty': 'No iiko departments are available for this posting',
    'workbench.allocation.department': 'Department',
    'workbench.allocation.pickDepartment': 'Department',
    'workbench.allocation.singleLineOnly': 'Only one allocation line can be submitted for now. Multi-line support is next.',
    'workbench.allocation.bankError': 'Failed to save bank account mapping',
    'workbench.allocation.refsError': 'Failed to load Syrve account and cash-flow catalogs',
    'workbench.allocation.draftSaved': 'Allocation draft saved ({count} lines). Posting to iiko comes next.',
    'workbench.allocation.draftSaveError': 'Could not save the allocation draft in this browser',
    'workbench.allocation.submitted': 'Allocation queued for iiko posting',
    'workbench.allocation.submitError': 'Failed to submit allocation',
    'workbench.warning.postingFailed': 'Syrve posting failed',
    'workbench.action.open': 'Open',
    'workbench.page.title': 'Accountant workbench',
    'workbench.page.subtitle': 'Review bank lines: matching, allocation, and stop reasons',
    'workbench.action.uploadStatement': 'Upload statement',
    'workbench.hint': 'Showing lines from the first {limit} recent imports. Ready to post = matched with no blockers. Posted payments are hidden in work filters.',
    'workbench.loading.imports': 'Loading recent bank imports…',
    'workbench.error.imports': 'Failed to load imports',
    'workbench.loading.transactions': 'Loading bank lines…',
    'workbench.error.transactions': 'Failed to load transactions',
    'workbench.empty.title': 'No rows for the selected filter',
    'workbench.empty.description': 'Try another filter or upload a new statement.',
    'workbench.action.post': 'Post payment',
    'workbench.action.confirmBalance': 'Confirm balance',
    'postingFlow.page.title': 'Payment posting',
    'postingFlow.page.subtitle': 'Allocate the payment, choose account/cash-flow, and wait for the Syrve result',
    'postingFlow.page.titlePosted': 'Posted payment',
    'postingFlow.page.subtitlePosted': 'This payment was already posted and reconciled in Syrve',
    'postingFlow.backToWorkbench': 'Back to workbench',
    'postingFlow.back': 'Back',
    'postingFlow.steps.allocate': 'Allocate',
    'postingFlow.steps.writeTarget': 'Write target',
    'postingFlow.steps.result': 'Result',
    'postingFlow.step.allocate.title': 'Allocate payment',
    'postingFlow.step.allocate.subtitle': 'Select documents and amounts, then confirm allocation with one action',
    'postingFlow.step.allocate.confirm': 'Confirm allocation',
    'postingFlow.settlement.allocationMethod': 'Allocation method',
    'postingFlow.settlement.method.fifo': 'FIFO',
    'postingFlow.settlement.method.manual': 'Manual',
    'postingFlow.settlement.bankPayment': 'Bank payment amount',
    'postingFlow.settlement.documentSettlement': 'Document settlement',
    'postingFlow.settlement.requiredAdvance': 'Future supplier advance',
    'postingFlow.settlement.unallocated': 'Unallocated from bank payment',
    'postingFlow.settlement.invoiceDebtRemaining': 'Invoice debt remaining',
    'postingFlow.settlement.partialDocument': 'Partial payment',
    'postingFlow.step.writeTarget.title': 'Where to post',
    'postingFlow.step.writeTarget.subtitle': 'Select account and cash-flow article, then send the payment to Syrve',
    'postingFlow.step.writeTarget.empty': 'Select account and cash-flow article — posting is blocked without them.',
    'postingFlow.step.writeTarget.rememberedHint': 'Using a previously remembered account and cash-flow. Change if needed.',
    'postingFlow.step.writeTarget.remember': 'Remember selection for future postings',
    'postingFlow.step.writeTarget.cta': 'Post to Syrve',
    'postingFlow.step.writeTarget.error': 'Failed to post payment to Syrve',
    'postingFlow.step.writeTarget.editAllocation': 'Back to allocation',
    'postingFlow.step.writeTarget.cancelError': 'Failed to cancel allocation',
    'postingFlow.block.balanceReview.hint': 'Bank statement balance does not match the recalculation — informational only. The bank is the source of truth; posting is not blocked.',
    'postingFlow.block.balanceReview.cta': 'Open import quality',
    'postingFlow.step.result.title': 'Posting result',
    'postingFlow.step.result.successTitle': 'Payment posted',
    'postingFlow.step.result.successPrefix': 'Document',
    'postingFlow.step.result.successSuffix': 'was paid and reconciled in Syrve. You can click Done.',
    'postingFlow.step.result.successSuffixReadOnly': 'was paid and reconciled in Syrve.',
    'postingFlow.step.result.success': 'Document {document} was paid and reconciled in Syrve. You can click Done.',
    'postingFlow.step.result.successReadOnly': 'Document {document} was paid and reconciled in Syrve.',
    'postingFlow.step.result.openDocument': 'Open document in Pay',
    'postingFlow.step.result.failed': 'Posting failed',
    'postingFlow.step.result.pending': 'Posting is in progress. This page refreshes automatically.',
    'postingFlow.step.result.approvalRequired': 'Posting is waiting for manual approval. Click Approve and send so the worker can send the payment to iiko.',
    'postingFlow.step.result.approve': 'Approve and send',
    'postingFlow.step.result.approveError': 'Failed to approve posting. Refresh the page and check the status.',
    'postingFlow.step.result.retry': 'Retry',
    'postingFlow.step.result.reconcile': 'Reconcile manually',
    'postingFlow.step.result.liveReadback': 'In Syrve: {status}, unpaid remaining {unpaid}',
    'postingFlow.step.result.done': 'Done',
    'postingFlow.summary.title': 'Summary',
    'postingFlow.summary.outcome': 'Outcome',
    'postingFlow.summary.outcomeSuccess': 'Payment posted and reconciled',
    'postingFlow.summary.outcomeFailed': 'Posting failed',
    'postingFlow.summary.outcomePending': 'Posting in progress',
    'postingFlow.summary.allocationStatus': 'Allocation status',
    'postingFlow.summary.postingStatus': 'Posting status',
    'postingFlow.diagnostics.title': 'Diagnostics',
    'postingFlow.diagnostics.allocation': 'Allocation',
    'postingFlow.diagnostics.preflight': 'Preflight',
    'postingFlow.diagnostics.workerAttempts': 'Worker attempts',
    'postingFlow.diagnostics.evidence': 'Evidence',
    'postingFlow.diagnostics.attempts': 'Attempts',
    'postingFlow.advanced.allocationDetail': 'Allocation details',
    'postingFlow.advanced.postingDetail': 'Posting details',
  },
  id: {
    'allocations.page.title': 'Alokasi pembayaran',
    'allocations.page.subtitle': 'Pilih dokumen Syrve, edit jumlah, dan konfirmasi alokasi',
    'allocations.page.error.missingBankTransactionId': 'ID transaksi bank tidak ditentukan.',
    'allocations.page.error.loadBankTransaction': 'Gagal memuat transaksi bank.',
    'allocations.page.backToCandidates': 'Ke kandidat',
    'allocations.candidates.title': 'Dokumen kandidat',
    'allocations.candidates.subtitle': 'Pilih satu atau lebih dokumen untuk alokasi',
    'allocations.candidates.build': 'Buat kandidat',
    'allocations.candidates.error.load': 'Gagal memuat kandidat.',
    'allocations.candidates.empty.title': 'Kandidat belum dibuat',
    'allocations.candidates.empty.description': 'Setelah mencocokkan counterparty, klik “Buat kandidat”.',
    'allocations.candidates.empty.noneFound.title': 'Dokumen yang cocok tidak ditemukan',
    'allocations.candidates.empty.noneFound.description': 'Periksa dokumen Syrve yang belum dibayar untuk counterparty yang cocok (jumlah, mata uang, outlet). Jika tidak ada, minta admin untuk sinkronkan data Syrve.',
    'allocations.candidates.selectAria': 'Pilih {label}',
    'allocations.candidates.amountAria': 'Jumlah untuk {label}',
    'allocations.candidates.openDocumentAria': 'Buka faktur {label}',
    'allocations.candidates.documentPreview.title': 'Faktur',
    'allocations.candidates.documentPreview.openFull': 'Buka faktur di halaman terpisah',
    'allocations.candidates.unpaid': 'Belum dibayar di iiko',
    'allocations.candidates.reserved': 'Sudah dialokasikan',
    'allocations.candidates.available': 'Tersedia',
    'allocations.candidates.remainingAfter': 'Sisa setelah operasi',
    'allocations.table.document': 'Dokumen',
    'allocations.table.outlet': 'Outlet',
    'allocations.table.counterparty': 'Counterparty',
    'allocations.table.amounts': 'Jumlah',
    'allocations.table.status': 'Status',
    'allocations.table.suggested': 'Disarankan',
    'allocations.table.confidence': 'Kepercayaan',
    'allocations.table.reason': 'Alasan',
    'allocations.table.warnings': 'Peringatan',
    'allocations.table.allocate': 'Alokasi',
    'allocations.table.documentAmount': 'Jumlah dokumen',
    'allocations.table.allocated': 'Dialokasi',
    'allocations.table.flags': 'Flag',
    'allocations.table.id': 'ID',
    'allocations.table.created': 'Dibuat',
    'allocations.table.statusBefore': 'Status sebelum',
    'allocations.table.statusAfter': 'Status diharapkan',
    'allocations.table.debt': 'Tunggakan',
    'allocations.outlet.undefined': 'Tidak ditentukan',
    'allocations.amounts.total': 'Total:',
    'allocations.amounts.paid': 'Dibayar:',
    'allocations.amounts.unpaid': 'Harus dibayar:',
    'allocations.warning.selectOutletManually': 'Pilih dokumen dan Outlet secara manual.',
    'allocations.preview.build': 'Buat pratinjau',
    'allocations.confirm.button': 'Konfirmasi alokasi',
    'allocations.preview.error': 'Gagal membuat pratinjau.',
    'allocations.confirm.error': 'Gagal mengonfirmasi alokasi.',
    'allocations.preview.title': 'Pratinjau alokasi',
    'allocations.summary.paymentAmount': 'Jumlah pembayaran',
    'allocations.summary.allocated': 'Dialokasi',
    'allocations.summary.remaining': 'Sisa',
    'allocations.summary.warnings': 'Peringatan',
    'allocations.flag.partialPayment': 'Pembayaran sebagian',
    'allocations.flag.overpayment': 'Lebih bayar',
    'allocations.preview.empty.title': 'Tidak ada baris pratinjau',
    'allocations.preview.empty.description': 'Pilih dokumen dan buat pratinjau.',
    'allocations.confirm.title': 'Konfirmasi alokasi',
    'allocations.confirm.message': 'Alokasi akan disimpan. Posting ke Syrve berjalan secara asinkron melalui antrean.',
    'allocations.confirm.label': 'Konfirmasi',
    'allocations.detail.notFound': 'Alokasi tidak ditemukan',
    'allocations.detail.title': 'Alokasi {id}…',
    'allocations.detail.subtitle': 'Transaksi bank {bankTransactionId}',
    'allocations.detail.approve': 'Setujui',
    'allocations.detail.queuePosting': 'Antrekan posting',
    'allocations.detail.summary': 'Ringkasan',
    'allocations.detail.bankTransaction': 'Transaksi bank',
    'allocations.detail.rowVersion': 'RowVersion',
    'allocations.detail.queueBlocked': 'Status alokasi saat ini tidak memungkinkan posting pembayaran diantrekan.',
    'allocations.detail.approveError': 'Gagal menyetujui alokasi. Segarkan halaman dan periksa status.',
    'allocations.detail.queueError': 'Gagal mengantrekan posting. Periksa preflight dan status saat ini.',
    'allocations.detail.linesTitle': 'Baris alokasi',
    'allocations.debt.before': 'Sebelum:',
    'allocations.debt.after': 'Sesudah:',
    'allocations.detail.linesEmpty.title': 'Baris tidak ditemukan',
    'allocations.detail.linesEmpty.description': 'Alokasi ini tidak memiliki baris.',
    'allocations.detail.postingPreview': 'Pratinjau posting',
    'allocations.detail.postingDisabled': 'Posting pembayaran dinonaktifkan oleh pengaturan',
    'allocations.detail.queueConfirm.title': 'Antrekan untuk posting?',
    'allocations.detail.queueConfirm.message': 'Pembayaran akan dikirim secara asinkron melalui outbox/worker, bukan sinkron dari UI.',
    'allocations.detail.writeTarget.title': 'Target posting pembayaran',
    'allocations.detail.writeTarget.hint': 'Pilih akun Syrve dan artikel arus kas. Jika tidak ada aturan posting, tentukan target secara manual di sini.',
    'allocations.detail.writeTargetRequired': 'Pilih akun dan artikel arus kas sebelum antrean.',
    'allocations.list.title': 'Alokasi pembayaran',
    'allocations.list.subtitle': 'Ruang kerja operasional: konfirmasi dan antrean posting',
    'allocations.list.statusFilter': 'Status: {status}',
    'allocations.list.empty': 'Belum ada alokasi',
    'allocations.list.subtitleCount': 'Catatan: {count}',
    'allocations.list.emptyHint': 'Daftar terisi setelah Confirm di halaman alokasi (bukan Preview). Buka workbench akuntan, pilih pembayaran, lalu konfirmasi alokasi.',
    'allocations.list.openWorkbench': 'Buka workbench akuntan',
    'allocations.list.error': 'Gagal memuat daftar. Periksa organisasi dan Outlet di header.',
    'allocations.dispatch.title': 'Pembayaran ke Syrve',
    'allocations.dispatch.subtitle': 'Satu daftar: yang perlu dikirim, yang sedang ke iiko, dan yang selesai',
    'allocations.dispatch.loading': 'Memuat pembayaran…',
    'allocations.dispatch.refresh': 'Segarkan',
    'allocations.dispatch.filters.all': 'Semua',
    'allocations.dispatch.filters.action': 'Perlu tindakan',
    'allocations.dispatch.filters.processing': 'Mengirim',
    'allocations.dispatch.filters.done': 'Selesai',
    'allocations.dispatch.filters.failed': 'Gagal',
    'allocations.dispatch.column.document': 'Dokumen',
    'allocations.dispatch.column.status': 'Status',
    'allocations.dispatch.column.nextStep': 'Langkah berikutnya',
    'allocations.dispatch.column.attempts': 'Percobaan iiko',
    'allocations.dispatch.column.action': 'Tindakan',
    'allocations.dispatch.action.continue': 'Buka',
    'allocations.dispatch.action.send': 'Kirim',
    'allocations.dispatch.action.retry': 'Ulangi',
    'allocations.dispatch.action.open': 'Detail',
    'allocations.dispatch.actionHint.continue': 'Buka pembayaran dan lanjutkan dari langkah saat ini',
    'allocations.dispatch.actionHint.send': 'Pilih akun dan artikel arus kas, lalu kirim ke Syrve dalam satu klik',
    'allocations.dispatch.empty.title': 'Belum ada pembayaran Syrve',
    'allocations.dispatch.empty.description': 'Alokasikan pembayaran di workbench akuntan terlebih dahulu — akan muncul di sini otomatis.',
    'allocations.dispatch.summary.total': 'Total',
    'allocations.dispatch.summary.action': 'Perlu tindakan',
    'allocations.dispatch.summary.processing': 'Mengirim',
    'allocations.dispatch.summary.done': 'Selesai',
    'allocations.dispatch.summary.pendingAmount': 'Jumlah tertunda',
    'allocations.bankCard.title': 'Pembayaran bank',
    'allocations.bankCard.counterpartyBank': 'Counterparty (bank)',
    'allocations.bankCard.syrveMatch': 'Pencocokan Syrve',
    'allocations.bankCard.notMatched': 'Belum cocok',
    'workbench.filter.ready': 'Siap posting',
    'workbench.filter.all': 'Dalam proses',
    'workbench.filter.posted': 'Diposting',
    'workbench.filter.problem': 'Bermasalah',
    'workbench.filter.unmatched': 'Belum cocok',
    'workbench.filter.conflict': 'Konflik',
    'workbench.filter.review': 'Perlu pemeriksaan',
    'workbench.filter.attention': 'Perlu perhatian',
    'workbench.filter.processing': 'Diproses',
    'workbench.filter.completed': 'Selesai',
    'workbench.filter.excluded': 'Dikecualikan',
    'workbench.filters.secondary': 'Sekunder',
    'workbench.state.attention': 'Perlu ditinjau',
    'workbench.state.ready': 'Siap diposting',
    'workbench.state.processing': 'Sedang diposting',
    'workbench.state.completed': 'Sudah diposting',
    'workbench.state.excluded': 'Bukan pembayaran pemasok',
    'workbench.table.document': 'Dokumen',
    'workbench.table.bank': 'Bank',
    'workbench.table.state': 'Status',
    'workbench.table.required': 'Diperlukan',
    'workbench.table.select': 'Pilih',
    'workbench.drawer.title': 'Operasi',
    'workbench.drawer.titleFrom': 'Operasi tanggal {date}',
    'workbench.drawer.sourceFile': 'File rekening koran',
    'workbench.drawer.required': 'Diperlukan',
    'workbench.drawer.warnings': 'Peringatan',
    'workbench.drawer.matchedRule': 'Dicocokkan oleh aturan',
    'workbench.drawer.writeTarget': 'Target tulis',
    'workbench.drawer.writeTargetPending': 'Ditentukan saat posting',
    'workbench.drawer.writeTargetMissing': 'Akun pembayaran dan artikel arus kas belum dipilih — atur di layar posting',
    'workbench.drawer.writeTargetConflict': 'Konflik aturan akun/arus kas — periksa aturan posting',
    'workbench.drawer.bankAccountResolution': 'Rekening bank dan Account keuangan',
    'workbench.bankAccount.resolved': 'Rekening bank sudah dipetakan',
    'workbench.reason.recognition_review_required': 'Perlu tinjauan pengenalan rekening',
    'workbench.reason.recognition_failed': 'Pengenalan rekening gagal',
    'workbench.reason.import_quality_error': 'Kesalahan kualitas impor',
    'workbench.reason.balance_review_required': 'Saldo rekening koran tidak cocok',
    'workbench.reason.duplicate_review_required': 'Perlu tinjauan duplikat',
    'workbench.reason.bank_account_mapping_required': 'Rekening bank belum dipetakan ke Account keuangan iiko',
    'workbench.reason.bank_account_mapping_conflict': 'Beberapa pemetaan aktif cocok dengan rekening bank ini',
    'workbench.reason.business_action_required': 'Menunggu pemilihan tindakan bisnis pada tahap workflow berikutnya',
    'workbench.reason.business_action_stale': 'Tindakan bisnis sudah kedaluwarsa setelah perubahan akun atau counterparty; pilih kembali',
    'workbench.reason.posting_intent_required': 'Tindakan bisnis sudah dipilih; detail posting disiapkan pada tahap workflow berikutnya',
    'workbench.reason.posting_intent_confirmation_required': 'Detail posting siap dan memerlukan konfirmasi eksplisit operator',
    'workbench.reason.posting_intent_stale': 'Detail posting kedaluwarsa setelah perubahan keputusan hulu; buat ulang',
    'workbench.reason.posting_execution_required': 'Detail posting telah dikonfirmasi dan siap dieksekusi',
    'workbench.reason.posting_execution_in_progress': 'Eksekusi posting sedang berlangsung',
    'workbench.reason.posting_reconciliation_required': 'Hasil posting belum terkonfirmasi dan memerlukan rekonsiliasi aman',
    'workbench.reason.posting_execution_failed': 'Posting gagal sebelum hasil terkonfirmasi diperoleh',
    'workbench.reason.posting_completed': 'Posting telah dikonfirmasi melalui rekonsiliasi',
    'workbench.reason.candidate_missing': 'Tidak ada dokumen belum dibayar dengan jumlah pembayaran untuk counterparty yang cocok',
    'workbench.reason.candidate_ambiguous': 'Beberapa kandidat dokumen — pilih manual',
    'workbench.reason.outlet_ambiguous': 'Outlet ambigu',
    'workbench.reason.allocation_partial': 'Alokasi sebagian',
    'workbench.reason.allocation_overpayment': 'Kelebihan bayar terhadap dokumen',
    'workbench.reason.allocation_warning': 'Alokasi perlu diperiksa',
    'workbench.reason.write_target_missing': 'Akun dan artikel arus kas belum dipilih',
    'workbench.reason.write_target_conflict': 'Konflik aturan akun/arus kas',
    'workbench.reason.posting_failed': 'Posting Syrve gagal',
    'workbench.reason.reconciliation_failed': 'Rekonsiliasi posting gagal',
    'workbench.reason.critical_anomaly': 'Anomali kritis',
    'workbench.next.openPosting': 'Buka posting',
    'workbench.next.prepare': 'Buka posting',
    'workbench.next.approveAndQueue': 'Setujui dan antrekan',
    'workbench.next.openResult': 'Buka hasil',
    'workbench.next.unexclude': 'Kembalikan ke proses',
    'workbench.action.reviewProblems': 'Tinjau masalah',
    'workbench.action.approveReady': 'Setujui yang siap',
    'workbench.action.approveReady.hint': 'Tersedia setelah batch approval',
    'workbench.batch.previewTitle': 'Setujui pembayaran siap',
    'workbench.batch.previewMessage': 'Layak: {eligible}. Dikecualikan: {excluded}. Total: {total}. Peringatan: {warnings}.',
    'workbench.batch.confirm': 'Setujui batch',
    'workbench.batch.result': 'Batch: berhasil {succeeded}, gagal {failed}, dilewati {skipped}',
    'workbench.batch.error': 'Batch approval gagal',
    'workbench.batch.noneEligible': 'Tidak ada pembayaran aman untuk batch (dikecualikan: {excluded})',
    'workbench.action.nextProblem': 'Masalah berikutnya',
    'workbench.action.unexclude': 'Pulihkan',
    'workbench.action.unexcludeFull': 'Kembalikan ke proses',
    'workbench.action.excludeNotPayment': 'Bukan pembayaran',
    'workbench.action.advancedMatching': 'Pencocokan lanjutan',
    'workbench.match.rememberRule': 'Ingat',
    'workbench.match.rulePattern': 'Pola pencocokan otomatis',
    'workbench.match.rulePatternHint': 'Impor berikutnya akan mencocokkan counterparty ini jika teks ini ditemukan. Anda dapat memendekkannya menjadi fragmen nama yang stabil.',
    'workbench.match.catalogMissing': 'Counterparty sudah dicocokkan tetapi tidak ada di katalog lokal. Konfirmasi pilihan saat ini atau sinkronkan pemasok.',
    'workbench.match.showAdvanced': 'Lanjutan',
    'workbench.match.hideAdvanced': 'Sembunyikan lanjutan',
    'workbench.match.blockingConflict': 'Konflik aturan memblokir: pencocokan disimpan, aturan tidak dibuat.',
    'workbench.match.excludedHint': 'Operasi dikecualikan dari pembayaran pemasok. Anda dapat mengembalikannya ke proses.',
    'workbench.action.prepare': 'Buka posting',
    'workbench.prepare.success': 'Kandidat diperbarui',
    'workbench.prepare.done': 'Persiapan selesai. Keputusan kandidat diperlukan.',
    'workbench.prepare.safeProposal': 'Dokumen aman: {document}',
    'workbench.prepare.counterpartyFromDocument': 'Counterparty ditentukan dari dokumen',
    'workbench.prepare.error': 'Gagal menyiapkan operasi',
    'workbench.action.approveAndQueue': 'Setujui dan antrekan',
    'workbench.action.openAdvancedFlow': 'Buka alur lanjutan',
    'workbench.approve.queued': 'Pembayaran masuk antrean',
    'workbench.approve.error': 'Gagal menyetujui dan mengantrikan',
    'workbench.approve.risk.title': 'Konfirmasi pembayaran berisiko',
    'workbench.approve.risk.confirm': 'Setujui dengan risiko',
    'workbench.approve.risk.unknown': 'Peringatan terdeteksi',
    'workbench.approve.risk.summary': 'Jumlah: {amount}. Peringatan: {warnings}. {message}',
    'workbench.filters.workflow': 'Status',
    'workbench.filters.issues': 'Masalah',
    'workbench.filters.dateFrom': 'Tanggal dari',
    'workbench.filters.dateTo': 'Tanggal sampai',
    'workbench.filters.document': 'Dokumen',
    'workbench.filters.document.placeholder': 'Nama file mutasi',
    'workbench.noDescription': 'Tidak ada deskripsi',
    'workbench.match.noMatch': 'Tidak cocok',
    'workbench.match.noMatchReason': 'Counterparty belum dicocokkan dengan Syrve.',
    'workbench.match.noCounterpartyFound': 'Counterparty yang sesuai tidak ditemukan.',
    'workbench.match.needsReview': 'Perlu pemeriksaan',
    'workbench.match.lowConfidenceReason': 'Kepercayaan pencocokan di bawah ambang aman.',
    'workbench.match.manual': 'Manual',
    'workbench.match.manualReason': 'Counterparty dipilih manual.',
    'workbench.match.auto': 'Otomatis',
    'workbench.match.autoReason': 'Pencocokan otomatis diterima.',
    'workbench.match.short.unmatched': 'Belum cocok',
    'workbench.match.short.review': 'Periksa',
    'workbench.match.short.manual': 'Manual',
    'workbench.match.short.rule': 'Aturan',
    'workbench.match.short.auto': 'Otomatis',
    'workbench.warning.counterpartyUnmatched': 'Rekanan belum cocok (tidak memblokir alokasi)',
    'workbench.warning.lowConfidence': 'Kepercayaan pencocokan rendah',
    'workbench.warning.importWarnings': 'Peringatan impor: {count}',
    'workbench.warning.importErrors': 'Kesalahan impor: {count}',
    'workbench.warning.duplicateCandidates': 'Impor memiliki kandidat duplikat: {count}',
    'workbench.warning.balanceReviewRequired': 'Saldo rekening koran tidak cocok',
    'workbench.warning.balanceReviewRequired.hint': 'Informasi: perhitungan ulang saldo tidak cocok dengan file bank. Rekening koran adalah sumber kebenaran; posting tidak diblokir.',
    'workbench.action.match': 'Cocokkan',
    'workbench.action.edit': 'Ubah',
    'workbench.action.allocate': 'Alokasi',
    'workbench.action.rule': 'Aturan',
    'workbench.noBlockers': 'Tidak ada blocker',
    'workbench.reason': 'Alasan',
    'workbench.table.date': 'Tanggal',
    'workbench.table.amount': 'Jumlah',
    'workbench.table.direction': 'D/K',
    'workbench.table.purpose': 'Tujuan',
    'workbench.table.counterparty': 'Counterparty Syrve',
    'workbench.table.matching': 'Pencocokan',
    'workbench.table.allocation': 'Alokasi',
    'workbench.table.outlet': 'Outlet',
    'workbench.table.warnings': 'Peringatan',
    'workbench.table.actions': 'Tindakan',
    'workbench.drawer.bankCounterparty': 'Counterparty dari rekening koran',
    'workbench.drawer.statementText': 'Dari rekening koran',
    'workbench.counterparty.notSpecified': '—',
    'workbench.counterparty.notMatched': 'Belum dicocokkan',
    'workbench.counterparty.fromBank': 'dari rekening koran: {name}',
    'workbench.allocation.notAllocated': 'Belum dialokasi',
    'workbench.allocation.inProgress': 'Sudah dialokasi',
    'workbench.allocation.processing': 'Sedang dikirim',
    'workbench.allocation.posted': 'Sudah diposting',
    'workbench.allocation.failed': 'Posting gagal',
    'workbench.allocation.title': 'Alokasi',
    'workbench.allocation.hint': 'Alokasikan seluruh jumlah transaksi ke artikel arus kas dan akun Syrve. Sisa yang belum dialokasi tidak diizinkan. Jenis operasi tidak dipilih — ditentukan oleh akun dan arus kas.',
    'workbench.allocation.col.dds': 'Arus kas',
    'workbench.allocation.col.account': 'Akun koresponden',
    'workbench.allocation.col.comment': 'Komentar',
    'workbench.allocation.col.amount': 'Jumlah',
    'workbench.allocation.pickDds': 'Artikel arus kas',
    'workbench.allocation.pickAccount': 'Akun koresponden Syrve',
    'workbench.allocation.ownAccount': 'Akun sendiri: {name}',
    'workbench.allocation.ownAccountMissing': 'Akun sendiri belum dipetakan',
    'workbench.allocation.openBankAccounts': 'Atur rekening bank',
    'workbench.allocation.commentPlaceholder': 'Komentar',
    'workbench.allocation.add': 'Tambah baris',
    'workbench.allocation.remove': 'Hapus baris',
    'workbench.allocation.submit': 'Kirim alokasi',
    'workbench.allocation.balanced': 'Sudah dialokasi penuh',
    'workbench.allocation.remaining': 'Sisa: {amount}',
    'workbench.allocation.over': 'Kelebihan: {amount}',
    'workbench.allocation.sumMismatch': 'Total baris {allocated} harus sama dengan jumlah transaksi {target}',
    'workbench.allocation.fieldsRequired': 'Setiap baris perlu arus kas, akun, dan jumlah lebih dari nol',
    'workbench.allocation.needBankAccount': 'Petakan bank ke Account iiko di Rekening bank terlebih dahulu',
    'workbench.allocation.needMatch': 'Cocokkan pihak lawan terlebih dahulu (atau tandai bukan pembayaran)',
    'workbench.allocation.needDepartment': 'Pilih departemen untuk posting',
    'workbench.allocation.needDepartmentEmpty': 'Tidak ada departemen iiko yang tersedia untuk posting ini',
    'workbench.allocation.department': 'Departemen',
    'workbench.allocation.pickDepartment': 'Departemen',
    'workbench.allocation.singleLineOnly': 'Saat ini hanya satu baris alokasi yang dapat dikirim. Dukungan multi-baris menyusul.',
    'workbench.allocation.bankError': 'Gagal menyimpan pemetaan rekening bank',
    'workbench.allocation.refsError': 'Gagal memuat katalog akun dan arus kas Syrve',
    'workbench.allocation.draftSaved': 'Draf alokasi disimpan ({count} baris). Posting ke iiko menyusul.',
    'workbench.allocation.draftSaveError': 'Tidak dapat menyimpan draf alokasi di browser ini',
    'workbench.allocation.submitted': 'Alokasi masuk antrean posting iiko',
    'workbench.allocation.submitError': 'Gagal mengirim alokasi',
    'workbench.warning.postingFailed': 'Posting Syrve gagal',
    'workbench.action.open': 'Buka',
    'workbench.page.title': 'Meja kerja akuntan',
    'workbench.page.subtitle': 'Periksa baris bank: pencocokan, alokasi, dan alasan berhenti',
    'workbench.action.uploadStatement': 'Unggah rekening koran',
    'workbench.hint': 'Menampilkan baris dari {limit} impor terbaru pertama. Siap posting = sudah cocok tanpa blocker. Pembayaran terposting disembunyikan di filter kerja.',
    'workbench.loading.imports': 'Memuat impor bank terbaru…',
    'workbench.error.imports': 'Gagal memuat impor',
    'workbench.loading.transactions': 'Memuat baris bank…',
    'workbench.error.transactions': 'Gagal memuat transaksi',
    'workbench.empty.title': 'Tidak ada baris untuk filter yang dipilih',
    'workbench.empty.description': 'Coba filter lain atau unggah rekening koran baru.',
    'workbench.action.post': 'Posting',
    'workbench.action.confirmBalance': 'Konfirmasi saldo',
    'postingFlow.page.title': 'Posting pembayaran',
    'postingFlow.page.subtitle': 'Alokasi pembayaran, pilih akun/arus kas, dan tunggu hasil Syrve',
    'postingFlow.page.titlePosted': 'Pembayaran diposting',
    'postingFlow.page.subtitlePosted': 'Pembayaran ini sudah diposting dan direkonsiliasi di Syrve',
    'postingFlow.backToWorkbench': 'Kembali ke meja kerja',
    'postingFlow.back': 'Kembali',
    'postingFlow.steps.allocate': 'Alokasi',
    'postingFlow.steps.writeTarget': 'Tujuan posting',
    'postingFlow.steps.result': 'Hasil',
    'postingFlow.step.allocate.title': 'Alokasi pembayaran',
    'postingFlow.step.allocate.subtitle': 'Pilih dokumen dan jumlah, lalu konfirmasi alokasi dengan satu tindakan',
    'postingFlow.step.allocate.confirm': 'Konfirmasi alokasi',
    'postingFlow.settlement.allocationMethod': 'Metode alokasi',
    'postingFlow.settlement.method.fifo': 'FIFO',
    'postingFlow.settlement.method.manual': 'Manual',
    'postingFlow.settlement.bankPayment': 'Jumlah pembayaran bank',
    'postingFlow.settlement.documentSettlement': 'Pelunasan dokumen',
    'postingFlow.settlement.requiredAdvance': 'Uang muka pemasok mendatang',
    'postingFlow.settlement.unallocated': 'Belum dialokasikan dari pembayaran bank',
    'postingFlow.settlement.invoiceDebtRemaining': 'Sisa utang dokumen',
    'postingFlow.settlement.partialDocument': 'Pembayaran sebagian',
    'postingFlow.step.writeTarget.title': 'Ke mana posting',
    'postingFlow.step.writeTarget.subtitle': 'Pilih akun dan artikel arus kas, lalu kirim pembayaran ke Syrve',
    'postingFlow.step.writeTarget.empty': 'Pilih akun dan artikel arus kas — posting diblokir tanpa keduanya.',
    'postingFlow.step.writeTarget.rememberedHint': 'Menggunakan akun dan arus kas yang diingat sebelumnya. Ubah jika perlu.',
    'postingFlow.step.writeTarget.remember': 'Ingat pilihan untuk posting berikutnya',
    'postingFlow.step.writeTarget.cta': 'Posting ke Syrve',
    'postingFlow.step.writeTarget.error': 'Gagal memposting pembayaran ke Syrve',
    'postingFlow.step.writeTarget.editAllocation': 'Kembali ke alokasi',
    'postingFlow.step.writeTarget.cancelError': 'Gagal membatalkan alokasi',
    'postingFlow.block.balanceReview.hint': 'Saldo rekening koran tidak cocok dengan perhitungan ulang — hanya informasi. Bank adalah sumber kebenaran; posting tidak diblokir.',
    'postingFlow.block.balanceReview.cta': 'Buka kualitas impor',
    'postingFlow.step.result.title': 'Hasil posting',
    'postingFlow.step.result.successTitle': 'Pembayaran diposting',
    'postingFlow.step.result.successPrefix': 'Dokumen',
    'postingFlow.step.result.successSuffix': 'dibayar dan direkonsiliasi di Syrve. Anda bisa klik Selesai.',
    'postingFlow.step.result.successSuffixReadOnly': 'dibayar dan direkonsiliasi di Syrve.',
    'postingFlow.step.result.success': 'Dokumen {document} dibayar dan direkonsiliasi di Syrve. Anda bisa klik Selesai.',
    'postingFlow.step.result.successReadOnly': 'Dokumen {document} dibayar dan direkonsiliasi di Syrve.',
    'postingFlow.step.result.openDocument': 'Buka dokumen di Pay',
    'postingFlow.step.result.failed': 'Posting gagal',
    'postingFlow.step.result.pending': 'Posting sedang berjalan. Halaman diperbarui otomatis.',
    'postingFlow.step.result.approvalRequired': 'Posting menunggu persetujuan manual. Klik Setujui dan kirim agar worker mengirim pembayaran ke iiko.',
    'postingFlow.step.result.approve': 'Setujui dan kirim',
    'postingFlow.step.result.approveError': 'Gagal menyetujui posting. Segarkan halaman dan periksa status.',
    'postingFlow.step.result.retry': 'Coba lagi',
    'postingFlow.step.result.reconcile': 'Rekonsiliasi manual',
    'postingFlow.step.result.liveReadback': 'Di Syrve: {status}, sisa belum dibayar {unpaid}',
    'postingFlow.step.result.done': 'Selesai',
    'postingFlow.summary.title': 'Ringkasan',
    'postingFlow.summary.outcome': 'Hasil',
    'postingFlow.summary.outcomeSuccess': 'Pembayaran diposting dan direkonsiliasi',
    'postingFlow.summary.outcomeFailed': 'Posting gagal',
    'postingFlow.summary.outcomePending': 'Posting sedang berjalan',
    'postingFlow.summary.allocationStatus': 'Status alokasi',
    'postingFlow.summary.postingStatus': 'Status posting',
    'postingFlow.diagnostics.title': 'Diagnostik',
    'postingFlow.diagnostics.allocation': 'Alokasi',
    'postingFlow.diagnostics.preflight': 'Preflight',
    'postingFlow.diagnostics.workerAttempts': 'Percobaan worker',
    'postingFlow.diagnostics.evidence': 'Evidence',
    'postingFlow.diagnostics.attempts': 'Percobaan',
    'postingFlow.advanced.allocationDetail': 'Detail alokasi',
    'postingFlow.advanced.postingDetail': 'Detail posting',
  },
} as const;
